import { NavigateFunction } from 'react-router-dom'

const LAMENESS_PAGE_PATH = '/cattles/lameness'
export const CHECKUP_SAVED_EVENT = 'sf:checkup-saved'

export type CheckupSavedNotice = {
	title: string
	description?: string
	isError?: boolean
}

export const broadcastCheckupSavedNotice = (notice: CheckupSavedNotice) => {
	if (typeof window === 'undefined') return false
	if (!window.opener || window.opener.closed) return false

	window.opener.postMessage(
		{ type: CHECKUP_SAVED_EVENT, notice },
		window.location.origin,
	)
	return true
}

export const openInNewBrowserTab = (path: string) => {
	const url = path.startsWith('http')
		? path
		: `${window.location.origin}${path}`
	window.open(url, '_blank', 'noopener,noreferrer')
}

export const openCheckupInNewTab = (path: string) => {
	const url = path.startsWith('http')
		? path
		: `${window.location.origin}${path}`
	window.open(url, '_blank')
}

export const leaveCheckupPage = (navigate: NavigateFunction) => {
	window.close()

	window.setTimeout(() => {
		if (window.history.length > 1) {
			navigate(-1)
			return
		}
		navigate(LAMENESS_PAGE_PATH)
	}, 100)
}
